import React, { useState } from "react";
import { CollapseArrow } from "~/assets/svg/InterfaceIcon";
import { useTranslation } from "react-i18next";
import DarkDefaultProfileImg from "~/assets/img/defaultImg/dark-profile-large2.png";
import LightDefaultProfileImg from "~/assets/img/defaultImg/light-profile-large.png";
import { useGlobalStore } from "~/store";

// Assets

const Complete = ({ detailData, company }) => {
	const { t } = useTranslation();
	const [doActive, setDoActive] = useState(false);

	const [
		{
			theme: { theme },
		},
	] = useGlobalStore();

	return (
		<>
			{/*완료 - 닫기*/}
			<section className={`c__card evaluate-card complete-card ${doActive && "active"}`}>
				<div className="top">
					<h5 className="percent">
						{!detailData
							? 0
							: Number.isInteger(detailData.score) === true
							? detailData.score
							: parseFloat(detailData.score).toFixed(2)}
						<i>{t("pages.investment.InvestEvalPage.detail.Step.complete.percent")}</i>
					</h5>
					<p className="main">
						{t("pages.investment.InvestEvalPage.detail.Step.complete.main")}
					</p>
					<p className="sub pre">
						{t("pages.investment.InvestEvalPage.detail.Step.complete.sub")}
					</p>
				</div>
				<div className="content">
					<ul className="commentary-wrap">
						{detailData?.Judge?.map((d) => (
							<li className="commentary" key={d.idx}>
								<p className="img-wrap">
									<img
										src={
											d.VcUser.img ||
											(theme === "dark"
												? DarkDefaultProfileImg
												: LightDefaultProfileImg)
										}
										alt={t(
											"pages.investment.InvestEvalPage.detail.Step.complete.imageAlt01"
										)}
									/>
									{/*<img src={d.VcUser.img || lightProfileImg} alt="심사역" />*/}
								</p>
								<dl className="commentary-text">
									<dt className="judge">
										{company?.name}
										<b>{d.VcUser.UserProfile.name}</b>
									</dt>
									<dd className="text">
										{d.comment ||
											t(
												"pages.investment.InvestEvalPage.detail.Step.complete.message"
											)}
									</dd>
								</dl>
							</li>
						))}
					</ul>
					<div className="total-commentary-wrap">
						<div className="img-wrap">
							<img
								src={
									detailData?.VcCompany?.logoSqu ||
									(theme === "dark"
										? DarkDefaultProfileImg
										: LightDefaultProfileImg)
								}
								alt={t(
									"pages.investment.InvestEvalPage.detail.Step.complete.imageAlt02"
								)}
							/>
							{/*<img src={detailData?.VcCompany?.logoSqu || lightProfileImg} alt="투자자 로고" />*/}
						</div>
						<div className="total-commentary">
							<p className="vc">{company?.name}</p>
							<p className="text">{detailData.comment}</p>
						</div>
					</div>
				</div>
				<button
					type="button"
					className={`btn-collapse ${doActive && "active"}`}
					onClick={() => setDoActive(!doActive)}
				>
					{doActive
						? t("pages.investment.InvestEvalPage.detail.Step.complete.button01")
						: t("pages.investment.InvestEvalPage.detail.Step.complete.button02")}
					<CollapseArrow />
				</button>
			</section>
		</>
	);
};

export default Complete;
